import CSS from "./PrivacyPolicyCSS.module.css";

const PrivacyPolicy = () => {
  return (
    <main className={CSS["privacy-policy"]}>
      <h1>Privacy Policy.</h1>
      <p>
        Welcome to Gerda Cryo Carry Sp. z. o. o. (“we”, “us”, “our”). We value
        your privacy and are committed to protecting your personal data. This
        Privacy Policy explains how we collect, use, disclose, transfer, and
        store your information when you visit or interact with our
        website www.gerda-cryocarry.com and related services, and how we comply
        with applicable data protection laws, including the GDPR (for users in
        the EU) and the CCPA (for users in California, USA).
      </p>
      <p>
        When you visit our website, subscribe to a newsletter, register an
        account, place an order, contact us, or otherwise provide us with
        personal information, you trust us with that information. We take that
        trust seriously.
      </p>
      <h2>What Information We Collect</h2>
      <p>
        When you engage with our website, we may collect personal data you
        voluntarily provide, such as your name, email address, postal address,
        phone number, billing or shipping information, and payment data. If you
        create an account with us, we may collect login credentials (username
        and password) and profile information. We also automatically collect
        usage-related data — for example, your IP address, browser type, device
        identifiers, pages viewed, and time spent on our site. Cookies, pixels,
        and other tracking technologies may also be used to track your
        interactions across the site and to deliver analytics and advertising.
      </p>
      <h2>How We Use Your Information</h2>
      <p>
        We process your personal data to deliver the services you request — for
        example, to process your orders, manage your account, communicate with
        you about your orders, and respond to your inquiries. We also use your
        data to maintain and improve our website and services, to conduct
        analysis, and to personalize your experience. Where permitted or
        required by law, with your consent, we may use your data for marketing
        and advertising purposes. We also comply with legal and regulatory
        obligations, such as financial or tax reporting, and protect our rights
        or the rights of others.
      </p>
      <h2>Legal Basis for Processing (GDPR)</h2>
      <p>In jurisdictions under the GDPR, we rely on legal bases such as:</p>
      <ul>
        <li>
          your consent, for instance for marketing communications or cookies;
        </li>
        <li>
          the performance of a contract — for example, when you place an order
          or use a service;
        </li>
        <li>
          legal obligations — for example, record-keeping or reporting
          requirements;
        </li>
        <li>
          and legitimate interests, where we have assessed that our interests
          (such as fraud prevention, network and information security, improving
          services) outweigh your privacy interests, provided your data rights
          are respected.
        </li>
      </ul>
      <p>
        For California residents under the CCPA, we disclose the categories of
        personal data collected and the purposes of processing, and you have the
        right to opt out of “selling” or “sharing” your data when applicable.
      </p>
      <h2>Sharing and Transfer of Data</h2>
      <p>
        We may share your personal data with service providers and third parties
        who assist us in website hosting, data storage, analytics, payment
        processing, marketing, and customer support. Those third parties are
        bound by confidentiality and data protection obligations. In some cases,
        we may be required by law to disclose your data (for example, to
        government agencies or law enforcement).
      </p>
      <p>
        When data is transferred outside the European Economic Area (EEA), we
        take steps to ensure adequate protection — for example, by using
        Standard Contractual Clauses or other lawful safeguards.
      </p>
      <h2>Data Retention</h2>
      <p>
        We retain your personal data for as long as necessary to fulfill the
        purposes for which it was collected, or to comply with legal retention
        periods. After that, we securely delete or anonymize your data.
      </p>
      <h2>Your Rights</h2>
      <p>
        Depending on your location, you may have rights regarding your personal
        data:
      </p>
      <ul>
        <li>
          Under GDPR: to access, correct, delete, or restrict processing of your
          data; to object to processing; to portability; and to withdraw consent
          at any time.
        </li>
        <li>
          Under CCPA (for California residents): to request the categories of
          personal data collected; to request deletion; to opt-out of
          sale/sharing; and to receive equal service/price even if you exercise
          your rights.
        </li>
      </ul>
      <p>
        To exercise any of these rights or if you have questions, contact us
        at gerda.medicaltransport@gmail.com We may ask you to verify your
        identity before processing your request to protect your security.
      </p>
      <h2>Cookies and Tracking Technologies</h2>
      <p>
        We use cookies, tracking pixels, and similar mechanisms to enhance
        functionality, analyze usage, and deliver personalized content or
        advertisements. You can manage or disable cookies through your browser
        settings; however, disabling certain cookies may affect your ability to
        use some features of the website.
      </p>
      <h2>Children’s Privacy</h2>
      <p>
        Our services are not intended for children under [13 / 16, depending on
        jurisdiction], and we do not knowingly collect data from them. If we
        discover that we inadvertently collected data from a child, we will
        promptly delete it.
      </p>
      <h2>Security Measures</h2>
      <p>
        We employ technical and organizational safeguards — such as encryption,
        access controls, secure servers, and staff training — to protect your
        personal data from unauthorized access, use, or disclosure. We strive to
        ensure your data is accurate, complete, and up to date.
      </p>
      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy as our business or applicable laws
        change. When we make changes, we will post the revised policy with the
        updated effective date. We encourage you to review this page
        periodically.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions, concerns, or would like to exercise your
        rights, please contact:
      </p>
      <p>Gerda Cryo Carry Sp. z. o. o. </p>
      <p>Email: gerda.medicaltransport@gmail.com</p>
      <p>
        Thank you for trusting us with your data. We promise to treat it
        responsibly and with respect.
      </p>
    </main>
  );
};

export default PrivacyPolicy;
